import { i18n } from '@/i18n';

const emailRegExp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const required = (v, text) => {
  const msg = text || i18n.t('common.RULE_REQUIRED');
  return Array.isArray(v) ? !!v.length || msg : !!v || msg;
};
const requiredNum = (v, text) => typeof v === 'number' || required(v, text);
const email = (v, text) => {
  const msg = text || i18n.t('common.RULE_EMAIL');
  return emailRegExp.test(v) || msg;
};
const maxLength = (v, length, text) => {
  const msg = text || i18n.t('common.RULE_MAX_LENGTH', { count: length });
  return `${v}` ? `${v}`.length <= length || msg : true;
};
const minLength = (v, length, text) => {
  const msg = text || i18n.t('common.RULE_MIN_LENGTH', { count: length });
  return `${v}` ? `${v}`.length > length || msg : true;
};

export default {
  required,
  requiredNum,
  email,
  maxLength,
  minLength
};
